import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useRoomSession } from '../../../../context/room_session';
import { useObservable } from '../../../../hooks/rxjs';
import { ToolbarButton } from './toolbar_button';
import { TooltipMessage } from './toolbar_tooltip_message';
import { useLocalVideoControllerState } from '../../../../hooks/use_local_video_controller_state';
import { Theme } from '@streem/ui-react';
export function ToggleCameraButton(props) {
    const roomSession = useRoomSession();
    const [localVideoController] = useObservable(roomSession.media.localVideoController);
    const [localVideoControllerState] = useLocalVideoControllerState(roomSession.media.localVideoController);
    const tooltipMessage = useMemo(() => {
        if (!localVideoControllerState || !localVideoControllerState.connected) {
            return 'Connecting...';
        }
        if (!localVideoControllerState.started) {
            return 'Looking for camera...';
        }
        if (localVideoControllerState.started && localVideoControllerState.enabled) {
            return 'Stop Camera';
        }
        if (localVideoControllerState.started && !localVideoControllerState.enabled) {
            return 'Start Camera';
        }
        return '';
    }, [localVideoControllerState]);
    if (!localVideoController) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(ToolbarButton, { "data-testid": tooltipMessage, tooltipMessage: _jsx(TooltipMessage, { text: tooltipMessage }), label: "Video", disableButton: localVideoControllerState?.connected === false, iconName: localVideoControllerState?.enabled ? 'CameraIcon' : 'CameraOffIcon', onClick: () => {
            if (localVideoController && localVideoControllerState) {
                localVideoController.setEnabled(!localVideoControllerState.enabled);
            }
        }, buttonStyles: {
            paddingRight: '.5rem',
            minWidth: '4.0rem',
        }, slashcolor: Theme.colors.red50, ...props }));
}
//# sourceMappingURL=toggle_camera_button.js.map